import '@mantine/core/styles.css';
import '@mantine/dates/styles.css';
import 'mantine-react-table/styles.css';
import './ChatOverrides.scss';

import {
    Avatar,
    ChatContainer,
    ConversationHeader,
    InfoButton,
    MainContainer,
    Message,
    MessageInput,
    MessageList,
    MessageSeparator,
    TypingIndicator,
} from '@chatscope/chat-ui-kit-react';
import {
    Box,
    Container,
    Flex,
    Group,
    MultiSelect,
    Portal,
    Select,
    Text,
} from '@mantine/core';
import { useDebouncedCallback, useLocalStorage } from '@mantine/hooks';
import { useMemo, useState } from 'react';

import ConversationContainer from './components/ConversationContainer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsis } from '@fortawesome/pro-solid-svg-icons';
import { useParams } from 'react-router-dom';

const ConversationView = ({ ...props }) => {
    const { id: conversationId } = useParams();
    return (
        <Container fluid>
            <ConversationContainer conversationId={conversationId} />
        </Container>
    );
};
export default ConversationView;
